import { render } from "./InputData.vue?vue&type=template&id=50421802&scoped=true"
import script from "./InputData.vue?vue&type=script&lang=js"
export * from "./InputData.vue?vue&type=script&lang=js"

import "./InputData.vue?vue&type=style&index=0&id=50421802&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-50421802"

export default script